// ========== FONCTION DE FORMATAGE DE NUMÉRO DE TÉLÉPHONE ==========
export const formatPhoneNumber = (phone: string): string => {
  if (!phone) return '';
  
  // Supprimer tous les espaces, tirets, parenthèses
  let cleaned = phone.replace(/[\s\-\(\)]/g, '');
  
  // Si le numéro commence par +, le garder tel quel
  if (cleaned.startsWith('+')) {
    // Supprimer tous les caractères non numériques sauf le +
    cleaned = '+' + cleaned.slice(1).replace(/\D/g, '');
  } else {
    // Sinon, supprimer tous les caractères non numériques
    cleaned = cleaned.replace(/\D/g, '');
    
    // Si le numéro commence par 0, le remplacer par +229 (Bénin)
    if (cleaned.startsWith('0')) {
      cleaned = '+229' + cleaned.slice(1);
    }
    // Si le numéro ne commence pas par + et fait moins de 10 chiffres, ajouter +229
    else if (cleaned.length < 10 && cleaned.length > 0) {
      cleaned = '+229' + cleaned;
    }
    // Si le numéro commence par un indicatif pays à 2 chiffres (comme 1 pour USA/Canada)
    else if (cleaned.startsWith('1') && cleaned.length === 10) {
      cleaned = '+' + cleaned;
    }
    // Si le numéro a exactement 9 chiffres (format local béninois sans 0)
    else if (cleaned.length === 9) {
      cleaned = '+229' + cleaned;
    }
  }
  
  return cleaned;
};